import {get} from "@/core/http";

export const api = {
    // 正在公告
    getZzggList: (params) => get("/api/jyxt/getGtzyList?zyzt=01", params),
    // 正在挂牌
    getZzgpList: (params) => get("/api/jyxt/getGtzyList?zyzt=02", params),
    // 结果公示
    getJggsList: (params) => get("/api/jyxt/getGtzyList?zyzt=03,04", params),
    // 所有挂牌
    getSygpList: (params) => get("/api/jyxt/getGtzyList?zyzt=02,03,04,05,06,07", params),

    // 正在资审
    getZzzsList: (params) => get("/api/jyxt/getGtzyList?zyzt=06", params),

    // 所有资源
    getSyzyList: (params) => get("/api/jyxt/getGtzyList?zyzt=01,02,03,04,06", params),

    getZzggPagination: (params) => get("/api/jyxt/getGtzyPage?zyzt=01", params),
    getZzgpPagination: (params) => get("/api/jyxt/getGtzyPage?zyzt=02", params),
    getJggsPagination: (params) => get("/api/jyxt/getGtzyPage?zyzt=03,04", params),
    getSygpPagination: (params) => get("/api/jyxt/getGtzyPage?zyzt=02,03,04,05,06,07", params),
    getZzzsPagination: (params) => get("/api/jyxt/getGtzyPage?zyzt=06", params),
    getSyzyPagination: (params) => get("/api/jyxt/getGtzyPage?zyzt=01,02,03,04,06", params),

    // 其他公告
    getQtggList: () => get("/api/jyxt/getQtggList?category=01"),
    // 更正公告
    getGtzyGzggList: (params) => get("/api/ggwz/getGgwzList?jyywlx=20,40&ggwzlx=07", params),
    getGtzyGzggPagination: (params) => get("/api/ggwz/getGgwzPage?jyywlx=20,40&ggwzlx=07", params),

    // 暂停公告
    getGtzyZtggList: (params) => get("/api/ggwz/getGgwzList?jyywlx=20,40&ggwzlx=02", params),
    getGtzyZtggPagination: (params) => get("/api/ggwz/getGgwzPage?jyywlx=20,40&ggwzlx=02", params),

    // 恢复公告
    getGtzyHfggList: (params) => get("/api/ggwz/getGgwzList?jyywlx=20,40&ggwzlx=03", params),
    getGtzyHfggPagination: (params) => get("/api/ggwz/getGgwzPage?jyywlx=20,40&ggwzlx=03", params),

    // 终止公告
    getGtzyZzggList: (params) => get("/api/ggwz/getGgwzList?jyywlx=20,40&ggwzlx=04", params),
    getGtzyZzggPagination: (params) => get("/api/ggwz/getGgwzPage?jyywlx=20,40&ggwzlx=04", params),

    // 通知公告
    getGtzyTzggList: (params) => get("/api/xw/getDataList?category=Tzgggl&tzggywlx=04", params),
    getGtzyTzggPagination: (params) => get("/api/xw/getDataPage?category=Tzgggl&tzggywlx=04", params),

    getGtzyQtggList: (params) => get("/api/ggwz/getGgwzList?jyywlx=20,40&ggwzlx=02,03,04,07", params),
    getGtzyQtggPagination: (params) => get("/api/ggwz/getGgwzPage?jyywlx=20,40&ggwzlx=02,03,04,07", params),

    // 正文
    getDetailById: (params) => get("/api/common/getDetail", params),

    // 附件
    getPic: (params) => get("/api/common/getFj?domain=GtzyFj&category=xct", params),
    getVideo: (params) => get("/api/common/getFj?domain=GtzyFj&category=sp", params),
    getFile: (params) => get("/api/common/getFj?domain=GtzyFj&category=gpcrwj", params),
    // 竞买信息
    getJmxx: (params) => get("/api/jyxt/getJmxx", params),
    // 全文搜索
    getQwssList: (params) => get("/api/jyxt/getGtzyList", params),
    getQwssPagination: (params) => get("/api/jyxt/getGtzyPage", params),

    // 资料下载
    getZlxzList: (params) => get("/api/common/getZlxzList?category=Wzzygl&jyywlx=20,40"),
    getZlxzPagination: (params) => get("/api/common/getZlxzPageInfo?category=Wzzygl&jyywlx=20,40"),

    // 附件
    getFj: (params) => get("/api/common/getFj", params),

    // 结果公示附件
    getJggsById: (params) => get("/api/common/getJggsById", params),

    getXmjyxq: (params) => get("/api/jyxt/xmjyxq", params),

    getXqxq: (params) => get("/api/jyxt/xqxq", params),
};

